// The whole code is copied from VPC.

export enum LocationTypes {
  Project = 'PROJECT',
  PersonalSpace = 'PERSONAL_SPACE',
  Unknown = 'UNKNOWN',
}

export interface ILocationInfo {
  type: LocationTypes;
  id: string;
  name: string;
}
